export const SERVICE_TRAIN_AND_TEST = "train-test";
export const SERVICE_ANNOTATION = "annotation";

export const serviceToLabel = {
  [SERVICE_TRAIN_AND_TEST]: "Train and Comparison",
  [SERVICE_ANNOTATION]: "Annotation",
};